import React, { forwardRef,useEffect, useRef, useState } from "react";
import cx from "classnames";

import { AutosizableTextArea as BaseAutosizableTextArea } from "@/ui-lib/FormFields/AutosizableTextArea";

import styles from "./AutosizableTextArea.module.scss";

const AutosizableTextArea = forwardRef(
  (
    {
      value,
      label,
      onChange,
      onBlur,
      onKeyDown,
      placeholder,
      className,
      id,
      inputClassName,
      debouncedTime = 500,
      disabled = false,
      autoFocus = false,
    },
    ref
  ) => {
    const [time, setTime] = useState(null);
    const [buffer, setBuffer] = useState(value);
    const inputRef = useRef();

    useEffect(() => {
      setBuffer(value);
    }, []);

    const inputChangeHandler = (event) => {
      const newValue = event.target.value;

      if (time) clearTimeout(time);

      setTime(
        setTimeout(() => {
          onChange(newValue);
        }, debouncedTime)
      );

      setBuffer(newValue);
    };

    const inputBlurHandler = (event) => {
      const newValue = event.target.value;

      if (onBlur) {
        onBlur(newValue);
        setBuffer(newValue);
      }
    };

    const inputKeyDownHandler = (event) => {
      if (onKeyDown) {
        onKeyDown(event);
      }
    };

    return (
      <div className={cx(styles.textAreaContainer, className)}>
        {label && <label htmlFor={id}>{label}</label>}
        <BaseAutosizableTextArea
          ref={ref || inputRef}
          placeholder={placeholder}
          inputClassName={inputClassName}
          id={id || ""}
          onChange={inputChangeHandler}
          onBlur={inputBlurHandler}
          onKeyDown={inputKeyDownHandler}
          value={buffer}
          disabled={disabled}
          autoFocus={autoFocus}
        />
      </div>
    );
  }
);

export default AutosizableTextArea;
